// extracted by mini-css-extract-plugin
export var actions = "_t6-4";
export var item = "_t6-1";
export var price = "_t6-3";
export var quantity = "_t6-2";
export var table = "_t6-0";